import clsx from 'clsx'
import React from 'react'
import type { ProgressVariantProps } from './Progress'
import { colors } from './Progress'

function Linear({
  'aria-label': label,
  'aria-labelledby': labelledBy,
  'aria-valuemax': max,
  'aria-valuemin': min,
  'aria-valuenow': now,
  'aria-valuetext': valueText,
  color,
  id,
  value,
}: ProgressVariantProps): JSX.Element {
  return (
    <div
      aria-label={labelledBy === undefined ? label : undefined}
      aria-labelledby={labelledBy}
      aria-valuemax={max}
      aria-valuemin={min}
      aria-valuenow={now}
      aria-valuetext={valueText}
      className={clsx(
        'flex relative w-full h-1 overflow-hidden',
        colors[color].track.linear,
      )}
      id={id}
      role="progressbar"
    >
      <div
        className={clsx(
          'flex h-full',
          colors[color].bar.linear,
          value === undefined
            ? 'animate-linear-indeterminate-1 absolute top-0 left-0 bottom-0 w-auto'
            : 'duration-200 ease-in transition-width will-change-width',
        )}
        style={value === undefined ? {} : { width: `${value}%` }}
      />
      {value === undefined ? (
        <div className="absolute top-0 bottom-0 left-0 transition-transform duration-200 origin-left animate-linear-indeterminate-2" />
      ) : null}
    </div>
  )
}

export default Linear
